<template>
    <div id="table-arrows" ref="arrows">
        <div class="arrow arrow-left" @click.stop="scrollWrapper('left')" v-show="left">
            &lt;
        </div>
        <div class="arrow arrow-right" @click.stop="scrollWrapper('right')" v-show="right">
            &gt;
        </div>
    </div>
</template>

<script>
export default {
    name: 'TableArrows',
    data: () => ({
        left: false,
        right: true,
        maxScroll: 0
    }),
    props: {
        table: Object,
        tableType: {
            type: String,
            default: 'default'
        }
    },
    mounted() {
        this.inject();
        this.resize();
        window.addEventListener('resize', this.resize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resize);
        this.wrapperNode.removeEventListener('scroll', this.checkScrollVisibility);
    },
    computed: {
        wrapper() {
            return this.table?.$el;
        },
        wrapperNode() {
            return this.table?.$el.querySelector('.v-data-table__wrapper');
        },
        tableItems() {
            return this.table?.items;
        },
        tableHeaders() {
            return this.table?.headers;
        }
    },
    watch: {
        wrapper() {
            this.inject();
            this.resize();
        },
        tableItems() {
            requestAnimationFrame(this.resize);
        },
        tableHeaders() {
            requestAnimationFrame(this.resize);
        }
    },
    methods: {
        resize() {
            if (!this.wrapper) return;

            this.checkScrollVisibility();
            this.calculateMaxScroll();
            this.calculateHeight();
        },
        inject() {
            if (!this.wrapper) return;

            this.wrapperNode.addEventListener('scroll', this.checkScrollVisibility);
            this.wrapper.style.position = 'relative';
            this.wrapper.appendChild(this.$refs.arrows);
        },
        calculateHeight() {
            const arrows = this.$refs.arrows;
            const height = this.wrapper.querySelector('th').clientHeight;
            const tableHeight = this.wrapperNode.querySelector('table').clientHeight;
            const scrollPadding = 2;

            let prependHeight = 0;
            for (const node of this.wrapper.childNodes) {
                if (node == this.wrapperNode) break;

                prependHeight += node.clientHeight;
            }

            arrows.style.top = `${height + prependHeight}px`;
            arrows.style.height = `${tableHeight - height - scrollPadding}px`;
        },
        calculateMaxScroll() {
            const node = this.wrapperNode;
            if (!node) return;

            node.scrollLeft = Number.MAX_SAFE_INTEGER;
            this.maxScroll = node.scrollLeft;
            node.scrollLeft = 0;
        },
        checkScrollVisibility() {
            const node = this.wrapperNode;
            if (!node) return;

            const canScroll = node.clientWidth < node.scrollWidth;
            const isMobile = window.innerWidth <= 450;
            const hasData = this.tableItems.length != 0;

            const conditions = canScroll && !isMobile && hasData;

            this.left = conditions && this.canScroll('left');
            this.right = conditions && this.canScroll('right');
        },
        canScroll(side) {
            const scroll = this.wrapperNode.scrollLeft;

            if (side == 'left') return scroll > 0;
            if (side == 'right') return scroll < this.maxScroll;
        },
        makeScrollData(side, speed) {
            const wrapper = this.wrapperNode;
            const comparator = side == 'left' ? (a, b) => a <= b : (a, b) => a >= b;
            const cooficient = side == 'left' ? -speed : speed;
            const target = wrapper.scrollLeft + cooficient;

            return {
                speed,
                wrapper,
                comparator,
                cooficient,
                target
            };
        },
        scrollWrapper(side) {
            const { comparator, wrapper, target, cooficient } = this.makeScrollData(side, 140);
            const ACCELERATION = 12;

            const slide = () => {
                this.checkScrollVisibility();
                if (comparator(wrapper.scrollLeft, target) || !this.canScroll(side)) return;

                wrapper.scrollLeft += cooficient / ACCELERATION;

                requestAnimationFrame(slide);
            };
            slide();
        }
    }
};
</script>

<style lang="scss" scoped>
#table-arrows {
    position: absolute;
    width: 100%;
    pointer-events: none;
}
.arrow {
    position: absolute;
    width: 1em;
    height: 100%;
    background-color: #363e59;
    opacity: 0.65;
    cursor: pointer;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    pointer-events: all;
}
.arrow-right {
    right: 0;
}
</style>
